import { Outlet } from 'react-router-dom';

import Footer from '../components/Footer';
import MainNavbar from '../components/MainNavbar';

function MainLayout() {
  return (
    <>
      <div className="container-fluid px-0" id="wrap">
        <MainNavbar />
        <Outlet />
      </div>

      <Footer />

    </>
  );
}

export default MainLayout;
